var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section-dark"},[_c('div',{staticClass:"container"},[(_vm.title)?_c('h2',{staticClass:"section-title",domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_c('div',{staticClass:"section-content"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }